import React from 'react';

import { Button, Grid, Stack } from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import PropTypes from 'prop-types';

const Buttons = ({
    cancelText = i18next.t('Cancel').toUpperCase(),
    confirmText = i18next.t('Accept').toUpperCase(),
    disabledBackButton,
    disabledConfirmButton,
    handleClickClose,
    handleClickSuccess,
    type,
}) => {
    if (type === 'confirm') {
        return (
            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
                <Grid>
                    <Button
                        disabled={disabledBackButton}
                        onClick={handleClickClose}
                        variant="outlined"
                    >
                        {cancelText}
                    </Button>
                </Grid>
                <Grid>
                    <Button
                        color="primary"
                        disabled={disabledConfirmButton}
                        onClick={handleClickSuccess}
                    >
                        {confirmText}
                    </Button>
                </Grid>
            </Stack>
        );
    }

    if (type === 'only_confirm') {
        return (
            <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
                <Grid>
                    <Button color="primary" onClick={handleClickSuccess}>
                        {confirmText}
                    </Button>
                </Grid>
            </Stack>
        );
    }

    return (
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
            <Grid>
                <Button color="primary" onClick={handleClickClose}>
                    {confirmText}
                </Button>
            </Grid>
        </Stack>
    );
};

Buttons.propTypes = {
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    disabledBackButton: PropTypes.bool,
    disabledConfirmButton: PropTypes.bool,
    handleClickClose: PropTypes.func,
    handleClickSuccess: PropTypes.func,
    type: PropTypes.string,
};

export default Buttons;
